"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.map.js");
var _react = _interopRequireDefault(require("react"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _classnames = _interopRequireDefault(require("classnames"));
var Menu = function Menu(props) {
  var title = props.title,
    tag = props.tag,
    children = props.children,
    curMenu = props.curMenu,
    _props$onClick = props.onClick,
    _onClick = _props$onClick === void 0 ? function (arg) {} : _props$onClick;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('nav');
  return /*#__PURE__*/_react.default.createElement("section", {
    className: "".concat(prefixCls, "__box")
  }, /*#__PURE__*/_react.default.createElement("header", {
    className: "".concat(prefixCls, "__box-hd")
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "__box-title")
  }, title), tag && /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "__tag")
  }, tag)), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__box-bd")
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "".concat(prefixCls, "__menu")
  }, children === null || children === void 0 ? void 0 : children.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: (0, _classnames.default)("".concat(prefixCls, "__menu-item"), {
        'is-active': curMenu === item.action
      }),
      key: index
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: "#",
      onClick: function onClick(e) {
        e.preventDefault();
        _onClick(item);
      }
    }, item.title));
  }))));
};
var _default = exports.default = Menu;